import { Route, Routes } from "react-router-dom"
import { ToastContainer } from 'react-toastify';
import './App.css';
import { AddAdmin, AddAgent, AddForm, AdminDashboard, Admins, Agents, ChangePassword, FarmerAssistant, FarmerCommunity, FarmerDashboard, FarmerProfile, FormDetail, Forms, Login, Maps, ResetPassword, ResetPasswordEmail, ResponseDetail, Responses } from "./pages";
import ROUTES from "../application/utils/Routes";

const App = () => {

  return (

    <div className="App">
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path={ROUTES.LOGIN} element={<Login />} />
        <Route path={ROUTES.DASHBOARD} element={<AdminDashboard />} />
        <Route path={ROUTES.FORMS} element={<Forms />} />
        <Route path={ROUTES.ADDFORM} element={<AddForm />} />
        <Route path={ROUTES.FORMDETAIL} element={<FormDetail />} />
        <Route path={ROUTES.AGENTS} element={<Agents />} />
        <Route path={ROUTES.ADDAGENTS} element={<AddAgent />} />
        <Route path={ROUTES.ADMINS} element={<Admins />} />
        <Route path={ROUTES.ADDADMINS} element={<AddAdmin />} />
        <Route path={ROUTES.MAPS} element={<Maps />} />
        <Route path={ROUTES.RESPONSES} element={<Responses />} />
        <Route path={ROUTES.RESPONSEDETAIL} element={<ResponseDetail />} />
        <Route path={ROUTES.RESESTPASSWORDEMAIL} element={<ResetPasswordEmail/>} />
        <Route path={ROUTES.RESESTPASSWORD} element={<ResetPassword />} />
        <Route path={ROUTES.CHANGEPASSWORD} element={<ChangePassword />} />
        <Route path={ROUTES.FARMERDASHBOARD} element={<FarmerDashboard />} />
        <Route path="/farmerprofile" element={<FarmerProfile />} />
        <Route path="/farmerassistant" element={<FarmerAssistant />} />
        <Route path="/farmercommunity" element={<FarmerCommunity />} />

      </Routes>
    </div>
  );
}

export default App;
